<template>
  <div :class="$style.getStartedInfoContainer">
    <div :class="$style.infoText">
      <span
        :class="$style.header"
      >
        {{ header }}
      </span>
      <span
        v-if="subheader"
        :class="$style.subheader"
      >
        {{ subheader }}
      </span>
      <div :class="$style.body">
        <ul>
          <li
            v-for="(listItem, index) in listItems"
            :key="listItem.text"
          >
            <img
              v-if="listItem.icon"
              :class="$style.lineIcon"
              :src="listItem.icon"
            >
            <span
              :class="[
                $style.line,
                { [$style.lineWithIcon]: listItem.icon },
              ]"
            >
              <MarkdownInline
                :mdTemplate="listItem.text"
              />
              <a
                v-if="listItem.link"
                :href="listItem.link"
                rel="noopener noreferrer"
                target="_blank"
                @click="linkEvent(header, listItem.linkText, listItem.link, `link${index}`)"
              >
                {{ listItem.linkText }}
              </a>
              <a
                v-else-if="listItem.actionText"
                rel="noopener noreferrer"
                target="_blank"
                @click="emitEvent(listItem.actionParameter)"
              >
                {{ listItem.actionText }}
              </a>
            </span>
          </li>
        </ul>
        <div v-if="isWistiaVideo">
          <span :class="$style.subheader">
            {{ wistiaDescription }}
          </span>
          <img
            :class="$style.thumbnail"
            :src="thumbnail"
            @click="handleOnClick"
          >
        </div>
        <div v-if="footerText">
          <img
            v-if="footerIconSrc"
            :class="$style.footerIcon"
            :src="footerIconSrc"
            svg-inline
          >
          <span
            :class="$style.footer"
          >
            {{ footerText }}
          </span>
        </div>
      </div>
    </div>
    <div
      v-if="cardImagePath"
      :class="$style.cardImage"
    >
      <img
        :class="$style.image"
        :src="cardImagePath"
      >
    </div>
  </div>
</template>

<script>
import { MarkdownInline } from '@jumpcloud/ui-components';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import ModalEventBus from 'components/Modal/ModalEventBus';
import VideoModal from 'client/components/Modal/VideoModal.vue';

export default {
  name: 'GetStartedInfo',

  components: {
    MarkdownInline,
  },

  EventHelper,
  ModalEventBus,

  props: {
    cardImagePath: {
      type: String,
      default: '',
    },
    footerIconSrc: {
      type: String,
      default: '',
    },
    footerText: {
      type: String,
      default: '',
    },
    header: {
      type: String,
      required: true,
    },
    isWistiaVideo: Boolean,
    listItems: {
      type: Array,
      required: true,
    },
    subheader: {
      type: String,
      default: '',
    },
    thumbnail: {
      type: String,
      default: '',
    },
    triggerEvent: {
      type: Function,
      default: () => {},
    },
    wistiaDescription: {
      type: String,
      default: '',
    },
    wistiaVideoUrl: {
      type: String,
      default: '',
    },
  },

  methods: {
    emitEvent(actionParameter) {
      this.$emit('actionClicked', actionParameter);
    },

    handleOnClick() {
      this.triggerEvent();
      this.$options.ModalEventBus.open({
        component: VideoModal,
        isLargeModal: true,
        componentProps: {
          videos: [
            {
              iframeUrl: this.wistiaVideoUrl,
              videoUrl: this.wistiaVideoUrl,
            },
          ],
        },
      });
    },

    linkEvent(title, text, url, type) {
      this.$options.EventHelper.triggerCollapsableSectionLinkClicked({
        sectionTitle: title,
        text,
        url,
        type,
      });
    },
  },
};
</script>

<style module>

@value ( max-width-medium-large ) from '~css/breakpoints.css';

.cardImage,
.infoText {
  display: flex;
  width: 100%;
}

.infoText {
  flex-direction: column;
}

.infoText a {
  cursor: pointer;
}

.getStartedInfoContainer {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  width: 100%;
}

.cardImage {
  margin: auto auto auto 25px;
  width: 70%;
}

.image {
  min-height: 250px;
  min-width: 450px;
}

.footer {
  display: inline-block;
  font-size: 1.15rem;
  line-height: 20px;
  margin-bottom: 20px;
  margin-left: 35px;
}

.header {
  font-size: 1.8rem;
  font-weight: 900;
  line-height: 30px;
  margin-bottom: 20px;
}

.subheader {
  font-size: 1.2rem;
  line-height: 24px;
  margin-bottom: 20px;
}

.body ul {
  padding-left: 0;
}

.body li {
  list-style: none;
  margin-bottom: 25px;
  padding: 0;
}

.line {
  display: inline-block;
  font-size: 1.3rem;
  line-height: 24px;
}

.lineWithIcon {
  margin-left: 45px;
}

.lineIcon {
  height: 20px;
  margin: 2px 0 0 15px;
  position: absolute;
  width: 20px;
}

.footerIcon {
  height: 20px;
  position: absolute;
  width: 20px;
}

.thumbnail {
  display: block;
  margin-top: 20px;
}

@media (max-width: max-width-medium-large) {
  .cardImage {
    display: none;
  }
}
</style>
